import styled from 'styled-components';

export const Box = styled.div.attrs(props => ({
  justifyContent: props.justifyContent || 'flex-start',
  alignItems: props.alignItems || 'flex-start',
  column: props.column || false
}))`
  display: flex;
  align-items: ${props => props.alignItems};
  justify-content: ${props => props.justifyContent};
  flex-direction: ${props => (props.column ? 'column' : 'row')};
`;
